<template>
<div>
  <div class="columns">
    <div class="column is-4">
      <text-input v-model="item" classes="has-addons">
        <template #right>
          <action-button @click="addItem">Add Array Item</action-button>
        </template>
      </text-input>
    </div>
    <div class="column is-flex align-center">
      [
        <span 
          @click="removeItem(item)"
          class="code-string mr pointer" 
          v-for="(item, index) in secondaryScraper.scraper_payload" 
          :key="index">
          {{ item }},
        </span>
      ]
    </div>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {

  data: () => ({
    item: ''
  }),

  created() {
    this.$store.commit('secondaryScraper/updateScraperPayload', [])
  },

  methods: {
    addItem() {
      const items = [...this.secondaryScraper.scraper_payload, this.item]
      this.$store.commit('secondaryScraper/updateScraperPayload', items)
      this.item = ''
    },
    removeItem(item) {
      const index = this.secondaryScraper.scraper_payload.indexOf(item)
      this.secondaryScraper.scraper_payload.splice(index, 1)
    }
  },
  
  computed: {
    ...mapGetters('secondaryScraper', [
      'secondaryScraper'
    ])
  }

}
</script>